import styled from 'styled-components'

export const MenuContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background-color: #0039c5;
  height: 100vh;
  min-height: 100vh;
  flex-shrink: 0;
  width: 294px;
  overflow: visible;
  z-index: 1000;
  box-shadow: #000 0px 0px 6px 1px;
  transition: width 0.3s;
  &.menu-close {
    width: 55px;
  }
  @media (width <= 1200px) {
    transform: translateX(-110%);
    transition: transform 0.3s ease;
    &.menu-open {
      transform: translateX(0);
      .btn-expandable {
        right: -1rem;
        top: 1.5rem;
      }
    }
  }
  @media (1200px < width) {
    transition: width 0.3s ease;
    &.menu-close {
      width: 55px;
      aside > span > p {
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.2s ease;
      }
      aside > section > div > p {
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.2s ease;
      }
      .btn-expandable {
        right: -1rem;
        bottom: 1.5rem;
        transform: rotate(180deg);
      }
    }
  }
  .btn-expandable {
    position: absolute;
    right: -1rem;
    bottom: 1.5rem;
    font-size: 35px;
    width: 35px;
    height: 35px;
    z-index: 10010;
    color: rgb(0, 0, 0);
    background-color: rgb(255, 255, 255);
    border-radius: 50%;
    border: none;
    cursor: pointer;
    transition: transform 0.3s ease;
    box-shadow: #000 0px 0px 9px 1px;
  }

`

export const Main = styled.aside`
  * {
    box-sizing: border-box;
  }

  ::-webkit-scrollbar {
    width: 10px;
  }
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #ececec;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background: #3a86ff;
    border-radius: 10px;
  }
  background-color: #0039c5;
  color: #f7f9fb;
  display: flex;
  flex-direction: column;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  height: 100vh;
  min-height: 100vh;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  .logo-open {
    align-self: center;
    margin-top: 8px;
    width: 240px;
    transition: opacity 0.3s ease;
    &.d-none {
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.3s ease;
    }
  }
  .logo-close {
    width: 25px;
    margin-left: 0.8rem;
    margin-top: 2rem;
    margin-bottom: 2.90rem;
    transition: opacity 0.3s ease;
    &.d-none {
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.3s ease;
    }
  }

  div,
  .link {
    align-items: center;
    color: #f7f9fb;
    cursor: pointer;
    display: flex;
    height: 44px;
    min-height: 44px;
    padding-left: 16px;
    text-decoration: none;
    width: 280px;

    img {
      height: 20px;
      width: 16px;
    }

    p {
      margin: 0px;
      margin-left: 16px;
      transition: opacity 0.2s ease;
    }

    #dropdown {
      margin-left: auto;
      margin-right: 22px;
      &.active {
        transform: rotate(-180deg);
      }
    }

    &:hover {
      background-color: #0133ae;
      box-shadow: 0px 6px 20px #0c3aad;
      border-radius: 8px 0px 0px 8px;
    }
  }

  .wrapper {
    margin-left: 51px;
    display: flex;
    flex-direction: column;

    .menuLink:link,
    .menuLink:visited {
      cursor: pointer;
      margin: 0px;
      margin-bottom: 16px;
      text-decoration: none;
      outline: none;
      color: white;

      &:first-child {
        margin-top: 16px;
      }
    }
  }

  hr {
    width: 234px;
    border: none;
    border-top: 1px solid #537de4;
    margin-bottom: 35px;
    margin-top: 40px;
  }

  > p {
    cursor: pointer;
    margin-left: 30px;
    margin-top: 64px;
    transition: opacity 0.2s ease;
  }
`
